import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=643d4f9c"
import script from "./RequestForm.vue?vue&type=script&lang=ts"
export * from "./RequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports